export default __webpack_public_path__ + "static/mobile-be92f0f1da2563846788383739489367.png";